function init() {
  document.querySelectorAll('.c-dropdown__option').forEach(function (option) {
    option.addEventListener('click', function () {
      if (!this.classList.contains('selected')) {
        if (this.parentNode.querySelector('.c-dropdown__option.selected')) {
          this.parentNode
            .querySelector('.c-dropdown__option.selected')
            .classList.remove('selected')
        }
        this.classList.add('selected')
        this.closest('.c-dropdown__select').querySelector(
          '.c-dropdown__trigger span'
        ).textContent = this.textContent
        this.closest('.c-dropdown').querySelector(
          '.c-dropdown__input'
        ).value = this.dataset.value
      } else {
        this.closest('.c-dropdown').querySelector(
          '.c-dropdown__title'
        ).textContent = this.textContent
      }
    })
  })

  document.querySelectorAll('.c-dropdown').forEach(function (dropdown) {
    if (dropdown.querySelector('.c-dropdown__option.selected')) {
      dropdown.querySelector(
        '.c-dropdown__title'
      ).textContent = dropdown.querySelector(
        '.c-dropdown__option.selected'
      ).textContent
    }
    dropdown.addEventListener('click', function () {
      this.querySelector('.c-dropdown__select').classList.toggle('open')
      if (
        this.querySelector('.c-dropdown__select').classList.contains('open')
      ) {
        this.querySelector('.c-dropdown__title').textContent = this.closest(
          '.c-dropdown'
        ).querySelector('.c-dropdown__input').name
      } else if (
        (this.querySelector(
          '.c-dropdown__title'
        ).textContent = this.querySelector('.c-dropdown__option.selected'))
      ) {
        this.querySelector(
          '.c-dropdown__title'
        ).textContent = this.querySelector(
          '.c-dropdown__option.selected'
        ).textContent
      } else {
        this.querySelector(
          '.c-dropdown__title'
        ).textContent = this.querySelector('.c-dropdown__input').name
      }

    })
  })

  document.querySelectorAll('.c-dropdown__trigger').forEach(function (title) {
    title.addEventListener('click', function () {
      if (this.closest('.c-dropdown__select').classList.contains('open')) {
        if (
          this.closest('.c-dropdown').querySelector(
            '.c-dropdown__option.selected'
          )
        ) {
          this.closest('.c-dropdown')
            .querySelector('.c-dropdown__option.selected')
            .classList.remove('selected')
        }
        this.querySelector('.c-dropdown__title').textContent = this.closest(
          '.c-dropdown'
        ).querySelector('.c-dropdown__input').name
        this.closest('.c-dropdown').querySelector('.c-dropdown__input').value =
          'all'
      }
    })
  })

  window.addEventListener('click', function (e) {
    document.querySelectorAll('.c-dropdown__select').forEach(function (select) {
      if (!select.contains(e.target)) {
        select.classList.remove('open')
      }
    })
  })
}

export default init
